import {configureStore} from "@reduxjs/toolkit";

import UserSingleReportStore from "./userSingleReport";
import UserReportsStore from "./userReports/index";
import RecruitingStore from './recruiting/index';
import EmployeesStore from "./employees/index";
import EasyMerchStore from "./easymerch/index";
import UnloadingsStore from "./unloadings";
import TunderStore from "./tunder/index";
import ChartsStore from "./charts";
import ProjectsStore from "./projects";
import RolesStore from "./accessRights";
import ThemeStore from "./theme/index";
import UserStore from "./user/index";
import MapStore from "./map";
import ContractsStore from "./contracts";
import ConsolidatedBudgetStore from "./consolidatedbudget";

const store = configureStore({
                                 reducer: {
                                     userSingleReport: UserSingleReportStore,
                                     userReports: UserReportsStore,
                                     unloadings: UnloadingsStore,
                                     recruiting: RecruitingStore,
                                     employees: EmployeesStore,
                                     easymerch: EasyMerchStore,
                                     projects: ProjectsStore,
                                     tunder: TunderStore,
                                     charts: ChartsStore,
                                     roles: RolesStore,
                                     theme: ThemeStore,
                                     user: UserStore,
                                     map: MapStore,
                                     contracts: ContractsStore,
                                     consolidatedbudget: ConsolidatedBudgetStore,
                                 },
                             });

export type AppDispatch = typeof store.dispatch;

export default store;
